import {Post} from "./Post";

export class PageDoc {
  id: number = 0;
  uid: string = "";
  name: string = "";
  label: string = "";
  doc_id: number = 0;
  // html_publish: string = ""
  lastUpdate: number = 0;
  lastPublish: number = 0;
  publish:boolean=false;
  priority:number=0;
  posts: Array<Post> = new Array<Post>();
  publish_posts: Array<Post> = new Array<Post>();
}
